import { inPast }                   from "../../lib/iprs-react-library/src/index.js";
import sortedArrayRemoveDuplicates  from './sortedArrayRemoveDuplicates';

const getEventSource = (api, cliniciansByID, appointmentTypeID, dates) => {
    
    const getDiariesForSlotsPromise = slots => {

        const clinicianPartyIDsForSlotsWithDuplicates =
            slots.flatMap(s => s.ClinicianPartyIDs)
                .toSorted((a, b) => a - b);
        const clinicianPartyIDsForSlots = sortedArrayRemoveDuplicates(clinicianPartyIDsForSlotsWithDuplicates);

        const diaryPromise = getClinicianDiaryPromise(clinicianPartyIDsForSlots);
        const slotPromise = Promise.resolve(slots);
        const allDiaryAndSlotPromises = Promise.all([diaryPromise, slotPromise]);

        return allDiaryAndSlotPromises;
    }

    const getClinicianDiaryPromise = clinicianPartyIDs => {
        const teamParams = {
            PartyIDs: clinicianPartyIDs,
            StartTime: dates.startDate,
            FinishTime: dates.finishDate
        };

        const teamPromise = api.transact('GetTeamDiary', teamParams)
            .then(response => response.apiResult)
            .then(diaryEvents => diaryEvents
                .filter(d => (1 !== d.RotaTypeID && true !== d.Deleted)) // exclude deleted events and availability
                .filter(d => (!(d.BookingID && d.AppointmentTypeID !== appointmentTypeID))) // exclude bookings for other appointment types
                .map(d => {
                    const isTask = (0 < (d.RotaTypeID ?? 0));
                    const type = isTask ? 'task' : 'booking';
                    const title = isTask ? d.Title : ('booking');
                    const clinician = cliniciansByID[d.PartyID];
                    const fullName = clinician?.FullName?? d.PartyID;
                    return { ...d, type, title, clinicianFullName: fullName };
                }));

        return teamPromise;
    }

    const getSlotsPromise = (api, appointmentTypeID) => {

        const availParams = {
            AppointmentTypeID: appointmentTypeID,
            Multiplier: 1,
            StartTime: dates.startDate,
            FinishTime: dates.finishDate,
            IncludeUnavailable: false
        };

        return api.transact('GetSlots', availParams)
            .then(response => response.apiResult)
            .then(slots => slots.map(s => ({...s, type: 'availability', title: 'Available'})));
    }
    
    return getSlotsPromise(api, appointmentTypeID)
        .then( slots => getDiariesForSlotsPromise(slots) )
        .then( events => events.flat() )
        .then( joinedResopnse => joinedResopnse.map( a => 
            { 
                const colour = inPast(a.StartTime) ? 'gray' : (('availability' === a.type)? 'red': (a.Colour?? 'blue'));
                //const title = JSON.stringify( a );
                const resourceIds = a.PartyID? [a.PartyID]: a.ClinicianPartyIDs;
                const result = { ...a, resourceIds, 
                            start: a.StartTime, end: a.FinishTime, 
                            backgroundColor: colour };
                return result;
             } ) )
};

export default getEventSource;